import { render, staticRenderFns } from "./TrRule.vue?vue&type=template&id=20c6b645&scoped=true&"
import script from "./TrRule.vue?vue&type=script&lang=js&"
export * from "./TrRule.vue?vue&type=script&lang=js&"
import style0 from "./TrRule.vue?vue&type=style&index=0&id=20c6b645&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c6b645",
  null
  
)

export default component.exports